import { Component } from '@angular/core';

@Component({
  selector: 'asw-hello-world-pres',
  templateUrl: './hello-world-pres.component.html',
  styleUrls: ['./hello-world-pres.component.scss'],
})
export class HelloWorldPresComponent {}
